// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jVGY","top":"styles_top__3gZSe"};